Revolution.Module.extend({
    NAME: "mde.edito", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/edito.js)
    windowHeight: '',
    gridTop: '',
    gridBottom: '',

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        //_.bindAll(this, "equalheight", "runEqualHeight", "getHeightsForOffsets");

        //events

        this.windowHeight = $(window).height();
        this.gridTop = this.windowHeight * .3;
        this.gridBottom = this.windowHeight * .6;

        this.initTocList()

        this.updateImgAside()
    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {
        this.updateToc();
    },

    onWindowResize: function (e) {
        this.updateImgAside()
    },

    updateToc: function (e) {
        $('.js-folder-page').each(_.bind(function (index, elem) {
            var toc = $('.js-bk-toc');
            var itemToc = toc.find('a[href="#' + $(elem).attr('id') + '"]');
            var thisTop = $(elem).offset().top - $(window).scrollTop();

            if (thisTop > this.gridTop && thisTop < this.gridBottom) {
                if (!itemToc.parent().hasClass('active')) {
                    toc.find('.active').removeClass('active');
                    itemToc.parent().addClass('active');
                }
            } else if (thisTop > this.gridTop && thisTop > this.gridBottom) {
                if (itemToc.parent().hasClass('active')) {
                    itemToc.parent().removeClass('active').prev().addClass('active');
                }
            }
        }, this));

        $(window).scroll(function() {
            if($('.js-bk-toc').length) {
                $('.js-toc-list').css('max-height',  $(window).height() - ($('.js-bk-toc').offset().top - $(window).scrollTop()) - 20);
            }
        });

        if($('.js-bk-toc').length) {
            $('.js-toc-list').css('max-height',  $(window).height() - ($('.js-bk-toc').offset().top - $(window).scrollTop()) - 20);
        }
    },

    initTocList: function () {
        if ($('.js-folder-page').length) {
            $('.js-folder-page').each(_.bind(function (index, elem) {
                $('.js-toc-list').append(this.htmlTocItem($(elem).attr('id'), $(elem).find('.js-folder-title').html()));
            }, this))
        }

        $('.js-toc-link').on('click', function () {
            setTimeout(_.bind(function () {
                $(this).parent().addClass('active').siblings('.active').removeClass('active');
            }, this), 1000);
        })
    },

    htmlTocItem: function (anchor, title) {
        var $html = $($('#template-toc-item').html());
        $html.find('a').attr('href', '#' + anchor).addClass('js-toc-link').html(title);

        return $html;
    },

    updateImgAside: function () {
        var windowWidth = $(window).width();

        if (windowWidth < 1280) {
            $('.js-wysiwyg-img-aside').removeAttr('style');
        } else {
            $('.js-wysiwyg-img-aside').each(function (index, elem) {
                var $bkWysiwyg = $(elem).closest('.js-bk-wysiwyg');
                var $WysiwygContent = $bkWysiwyg.find('.js-wysiwyg-content');
                var $WysiwygSmallContent = $bkWysiwyg.find('.js-wysiwyg-small-content');
                var paddingLeftWysiwygContent = ($bkWysiwyg.width() - $WysiwygContent.width()) / 2;

                $('.js-wysiwyg-img-aside').css('width', ($bkWysiwyg.width() - paddingLeftWysiwygContent - $WysiwygSmallContent.width()) + 'px');
            })
        }
    }

});
